var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat__message-bubble"},[_c('span',{staticClass:"important-text pt-10 pb-10",domProps:{"innerHTML":_vm._s(this.getMessageText(_vm.message.data.text))}})])}
var staticRenderFns = []

export { render, staticRenderFns }